<template>
  <div class="product-inner ">
    <text-editor-component :isInner="true" :contentData="contentData" />
  </div>
</template>

<script>
import TextEditorComponent from "./TextEditorComponent.vue";

export default {
  components: { TextEditorComponent },
  props: ["contentData"]
};
</script>

<style></style>
